/**
 * getUser.js
 * Written by: Alex Kasemir
 */

import { formatAxiosError } from 'utils';
import request from '../../../request/actions';
import { setAuthedUser } from '../setAuthedUser';

export const GET_USER_START = `GET_USER_START`;
export const GET_USER_SUCCESS = `GET_USER_SUCCESS`;
export const GET_USER_FAILURE = `GET_USER_FAILURE`;

export const getUserStart = () => ({
  type: GET_USER_START,
});

export const getUserSuccess = (user, id) => ({
  type: GET_USER_SUCCESS,
  user,
  id,
});

export const getUserFailure = (id, error) => ({
  type: GET_USER_FAILURE,
  id,
  error,
});

/**
 * Description of the getUser action
 */
export const getUser = (lookup = `me`, params = null) => {
  return async (dispatch) => {
    dispatch(getUserStart());
    try {
      const response = await dispatch(request(`/users/${lookup}/`, `GET`, null, params));
      if (lookup === `me`) {
        dispatch(setAuthedUser(response.data.id));
      }
      dispatch(getUserSuccess(
        response.data,
        params && params.referral ? response.data.username : response.data.id,
      ));
      return response.data;
    } catch (e) {
      dispatch(getUserFailure(lookup, e));
      if (e instanceof Error) {
        throw e;
      }
      const errorMsg = formatAxiosError(`getUser`, e);
      throw new Error(errorMsg);
    }
  };
};

export default getUser;
